import {Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {UuidService} from '@orga-app/providers/uuid.service';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {ModalController, NavController, Platform} from '@ionic/angular';
import {getTheme} from '@orga-app/settings/reducer';
import {SafeUrl} from '@angular/platform-browser';
import * as apiVeranstaltungen from '../../../../clients/veranstaltungen';
import * as fromAppState from '../../app-state/app-state.reducer';
import {getAktuelleVeranstaltung, getPlatform, GlobalAppState} from '../../app-state/app-state.reducer';
import { Router } from '@angular/router';

@Component({
    selector: 'app-page-checklisten-aufgaben',
    templateUrl: 'checklisten-aufgaben.page.html',
    styleUrls: ['./checklisten-aufgaben.page.scss']
})

export class ChecklistenAufgabenPage implements OnInit {
    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;
    public platformState$: Observable<string>;
    public platformState: string;

    heute: Date;

    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;

    constructor(public navCtrl: NavController,
                public modalCtrl: ModalController,
                public platform: Platform,
                private uuid: UuidService,
                private store: Store<GlobalAppState>,
                public settingsProvider: SettingsProvider,
                private storeVeranstaltung: Store<fromAppState.GlobalAppState>,
                private router: Router
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        // Platform from State
        this.platformState$ = this.storeVeranstaltung.pipe(select(getPlatform));

        this.aktuelleVeranstaltung$ = this.store.pipe(select(getAktuelleVeranstaltung));

        this.platformState$.subscribe(x => {
            this.platformState = x;
        }).unsubscribe();
    }

    ngOnInit() {
        // this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    ionViewWillEnter() {
        this.heute = new Date();
    }

    veranstaltungWechseln() {
        this.router.navigate(['/veranstaltung-auswaehlen', { returnTo: window.location.pathname }],
            {
                preserveFragment: true
            });
    }

}
